'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactCssModules = require('react-css-modules');

var _reactCssModules2 = _interopRequireDefault(_reactCssModules);

var _ = require('../');

var _FootprintDeprecated = require('./FootprintDeprecated.css');

var _FootprintDeprecated2 = _interopRequireDefault(_FootprintDeprecated);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// import config from '../../config'

var FootprintDeprecated = (_dec = (0, _reactCssModules2.default)(_FootprintDeprecated2.default), _dec(_class = function (_Component) {
  (0, _inherits3.default)(FootprintDeprecated, _Component);

  function FootprintDeprecated() {
    (0, _classCallCheck3.default)(this, FootprintDeprecated);
    return (0, _possibleConstructorReturn3.default)(this, (FootprintDeprecated.__proto__ || (0, _getPrototypeOf2.default)(FootprintDeprecated)).apply(this, arguments));
  }

  (0, _createClass3.default)(FootprintDeprecated, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        { styleName: 'footprint-deprecation-notice-wrap' },
        _react2.default.createElement(
          'div',
          { styleName: 'footprint-deprecation-notice-icon' },
          _react2.default.createElement(_.LinkIcon, { nospace: true, faclass: 'fa-exclamation-triangle' })
        ),
        _react2.default.createElement(
          'div',
          { styleName: 'footprint-deprecation-notice-text' },
          _react2.default.createElement(
            'h2',
            null,
            'WARNING: Carbon footprint data is no longer being updated.'
          ),
          _react2.default.createElement(
            'p',
            null,
            'As of 2023, we are no longer updating fund carbon footprint data. This is due to a lack of access to regularly-updated company-level carbon footprint data. We are looking into whether we can find a new source for this data. Until then, all fund carbon footprint data should be considered out of date.'
          )
        )
      );
    }
  }]);
  return FootprintDeprecated;
}(_react.Component)) || _class);
exports.default = FootprintDeprecated;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/FootprintDeprecated/FootprintDeprecated.js
// module id = 1378
// module chunks = 0